import { useCallback, useRef } from 'react';

import { useRouterContext } from 'contexts/router-context';
import { Route } from 'types';

function useThrottleClick(routeName?: Route, routeParam?: string, callback?: () => void, timeout = 1000) {
  const { next } = useRouterContext();
  const canClick = useRef<boolean>(true);

  return useCallback(() => {
    if (canClick.current) {
      if (callback) {
        callback();
      }

      if (routeName) {
        next({
          name: routeName,
          param: routeParam,
        });
      }

      canClick.current = false;

      // Disable click for 1 sec.
      setTimeout(() => canClick.current = true, timeout);
    }
  }, [next, routeName, routeParam, callback, timeout]);
}

export default useThrottleClick;
